// src/site-names.ts
var siteNames = {
  candidate: {
    seek: { au: "candidate-seek-au", nz: "candidate-seek-nz" },
    jobsdb: { hk: "candidate-jobsdb-hk", th: "candidate-jobsdb-th" },
    jobstreet: {
      sg: "candidate-jobstreet-sg",
      id: "candidate-jobstreet-id",
      ph: "candidate-jobstreet-ph",
      my: "candidate-jobstreet-my"
    }
  },
  employer: {
    seek: {
      au: "employer-seek-au",
      nz: "employer-seek-nz",
      hk: "employer-seek-hk",
      th: "employer-seek-th",
      sg: "employer-seek-sg",
      id: "employer-seek-id",
      ph: "employer-seek-ph",
      my: "employer-seek-my"
    }
  }
};

// src/site-config.ts
var createSites = (input) => input;
var siteConfig = createSites({
  "candidate-seek-root": {
    host: "www.seek.com",
    stagingHost: "www.staging.seek.com",
    languages: ["en"],
    classification: {
      product: "candidate",
      brand: "seek",
      country: null
    }
  },
  "candidate-seek-au": {
    host: "www.seek.com.au",
    stagingHost: "www.staging.seek.com.au",
    languages: ["en"],
    classification: {
      product: "candidate",
      brand: "seek",
      country: "au"
    }
  },
  "candidate-seek-nz": {
    host: "www.seek.co.nz",
    stagingHost: "www.staging.seek.co.nz",
    languages: ["en"],
    classification: {
      product: "candidate",
      brand: "seek",
      country: "nz"
    }
  },
  "candidate-jobsdb-hk": {
    host: "hk.jobsdb.com",
    stagingHost: "hk.staging.jobsdb.com",
    languages: ["en", "zh"],
    classification: {
      product: "candidate",
      brand: "jobsdb",
      country: "hk"
    }
  },
  "candidate-jobsdb-th": {
    host: "th.jobsdb.com",
    stagingHost: "th.staging.jobsdb.com",
    languages: ["en", "th"],
    classification: {
      product: "candidate",
      brand: "jobsdb",
      country: "th"
    }
  },
  "candidate-jobsdb-root": {
    host: "www.jobsdb.com",
    stagingHost: "www.staging.jobsdb.com",
    languages: ["en"],
    classification: {
      product: "candidate",
      brand: "jobsdb",
      country: null
    }
  },
  "candidate-jobstreet-sg": {
    host: "sg.jobstreet.com",
    stagingHost: "sg.staging.jobstreet.com",
    alternatives: {
      topLevelRegion: {
        host: "www.jobstreet.com.sg",
        stagingHost: "www.staging.jobstreet.com.sg"
      }
    },
    languages: ["en"],
    classification: {
      product: "candidate",
      brand: "jobstreet",
      country: "sg"
    }
  },
  "candidate-jobstreet-id": {
    host: "id.jobstreet.com",
    stagingHost: "id.staging.jobstreet.com",
    alternatives: {
      topLevelRegion: {
        host: "www.jobstreet.co.id",
        stagingHost: "www.staging.jobstreet.co.id"
      }
    },
    languages: ["id", "en"],
    classification: {
      product: "candidate",
      brand: "jobstreet",
      country: "id"
    }
  },
  "candidate-jobstreet-ph": {
    host: "ph.jobstreet.com",
    stagingHost: "ph.staging.jobstreet.com",
    alternatives: {
      topLevelRegion: {
        host: "www.jobstreet.com.ph",
        stagingHost: "www.staging.jobstreet.com.ph"
      }
    },
    languages: ["en"],
    classification: {
      product: "candidate",
      brand: "jobstreet",
      country: "ph"
    }
  },
  "candidate-jobstreet-my": {
    host: "my.jobstreet.com",
    stagingHost: "my.staging.jobstreet.com",
    alternatives: {
      topLevelRegion: {
        host: "www.jobstreet.com.my",
        stagingHost: "www.staging.jobstreet.com.my"
      }
    },
    languages: ["en"],
    classification: {
      product: "candidate",
      brand: "jobstreet",
      country: "my"
    }
  },
  "candidate-jobstreet-root": {
    host: "www.jobstreet.com",
    stagingHost: "www.staging.jobstreet.com",
    languages: ["en"],
    classification: {
      product: "candidate",
      brand: "jobstreet",
      country: null
    }
  },
  "employer-seek-au": {
    host: "talent.seek.com.au",
    stagingHost: "talent.staging.seek.com.au",
    languages: ["en"],
    classification: {
      product: "employer",
      brand: "seek",
      country: "au"
    }
  },
  "employer-seek-nz": {
    host: "talent.seek.co.nz",
    stagingHost: "talent.staging.seek.co.nz",
    languages: ["en"],
    classification: {
      product: "employer",
      brand: "seek",
      country: "nz"
    }
  },
  "employer-seek-hk": {
    host: "hk.employer.seek.com",
    stagingHost: "hk.employer.staging.seek.com",
    languages: ["en"],
    classification: {
      product: "employer",
      brand: "seek",
      country: "hk"
    }
  },
  "employer-seek-th": {
    host: "th.employer.seek.com",
    stagingHost: "th.employer.staging.seek.com",
    languages: ["en", "th"],
    classification: {
      product: "employer",
      brand: "seek",
      country: "th"
    }
  },
  "employer-seek-sg": {
    host: "sg.employer.seek.com",
    stagingHost: "sg.employer.staging.seek.com",
    languages: ["en"],
    classification: {
      product: "employer",
      brand: "seek",
      country: "sg"
    }
  },
  "employer-seek-id": {
    host: "id.employer.seek.com",
    stagingHost: "id.employer.staging.seek.com",
    languages: ["id", "en"],
    classification: {
      product: "employer",
      brand: "seek",
      country: "id"
    }
  },
  "employer-seek-ph": {
    host: "ph.employer.seek.com",
    stagingHost: "ph.employer.staging.seek.com",
    languages: ["en"],
    classification: {
      product: "employer",
      brand: "seek",
      country: "ph"
    }
  },
  "employer-seek-my": {
    host: "my.employer.seek.com",
    stagingHost: "my.employer.staging.seek.com",
    languages: ["en"],
    classification: {
      product: "employer",
      brand: "seek",
      country: "my"
    }
  }
});
var isSiteName = (value) => value in siteConfig;
var isCountrySiteName = (value) => isSiteName(value) && siteConfig[value].classification.country !== null;
var products = Object.values(siteConfig).map(
  (site) => site.classification.product
);
var isProduct = (value) => products.includes(value);
var brands = Object.values(siteConfig).map(
  (site) => site.classification.brand
);
var isBrand = (value) => brands.includes(value);
var countries = Object.values(siteConfig).map((site) => site.classification.country).filter(
  (country) => country !== null
);
var isCountry = (value) => countries.includes(value);

// ../../private/common-types/src/non-standard-homepage-hack.ts
var isNonStandardHomepageLanguageSite = (site) => site in nonStandardHomepageDefaultLanguages;
var nonStandardHomepageDefaultLanguages = {
  "candidate-jobsdb-th": "th",
  "candidate-jobstreet-id": "id"
};

// ../../private/util-functions/src/join-paths.ts
var joinPaths = (segments, options) => {
  let joinedPath = "";
  for (const segment of segments) {
    if (!segment || segment === "/") {
      continue;
    }
    let newSegment = segment;
    if (newSegment[0] === "/") {
      newSegment = newSegment.slice(1);
    }
    if (newSegment[newSegment.length - 1] === "/") {
      newSegment = newSegment.slice(0, -1);
    }
    joinedPath += `${newSegment}/`;
  }
  if (options?.leading) {
    joinedPath = `/${joinedPath}`;
  }
  if (!options?.trailing) {
    joinedPath = joinedPath.slice(0, -1);
  }
  let doubleSlashIndex = joinedPath.indexOf("//");
  while (doubleSlashIndex !== -1) {
    joinedPath = joinedPath.replace("//", "/");
    doubleSlashIndex = joinedPath.indexOf("//");
  }
  return joinedPath;
};

// ../../private/util-functions/src/object-keys.ts
var objectKeys = (input) => Object.keys(input);

// src/alternatives.ts
var getAlternatives = (site) => {
  const config = siteConfig[site];
  return "alternatives" in config ? config.alternatives ?? {} : {};
};
var getAlternativeHosts = (site, staging) => Object.values(getAlternatives(site)).map(
  ({ host, stagingHost }) => staging ? stagingHost : host
);
var getAlternativeHost = (site, staging, name) => {
  const { host, stagingHost } = getAlternatives(site)[name] ?? {};
  return staging ? stagingHost : host;
};

// src/languages.ts
var languages = ["en", "th", "id", "zh"];
var isLanguage = (value) => languages.includes(value);
var locales = [
  "en-AU",
  "en-HK",
  "en-ID",
  "en-MY",
  "en-NZ",
  "en-PH",
  "en-SG",
  "en-TH",
  "th-TH",
  "id-ID",
  "zh-HK"
];
var isLocale = (value) => locales.includes(value);
var appLanguageLocales = [
  { name: "en-AU", extends: "en" },
  { name: "en-HK", extends: "en" },
  { name: "en-ID", extends: "en" },
  { name: "en-MY", extends: "en" },
  { name: "en-NZ", extends: "en" },
  { name: "en-PH", extends: "en" },
  { name: "en-SG", extends: "en" },
  { name: "en-TH", extends: "en" },
  { name: "th-TH", extends: "th" },
  { name: "id-ID", extends: "id" },
  { name: "zh-HK", extends: "zh" }
];
var appLanguages = [...languages, ...appLanguageLocales];
var defaultLanguage = "en";
var getLocale = (site, language) => {
  const country = siteConfig[site].classification.country;
  if (!country) {
    return language;
  }
  return `${language}-${country.toUpperCase()}`;
};
var getLanguageFromLocale = (locale) => locale.slice(0, 2);

// src/site-utils.ts
var findRootSite = (product, brand) => objectKeys(siteConfig).find((site) => {
  const { classification } = siteConfig[site];
  return classification.product === product && classification.brand === brand && classification.country === null;
});
var findNonRootSite = (product, country) => objectKeys(siteConfig).find((site) => {
  const { classification } = siteConfig[site];
  return classification.product === product && classification.country === country;
});

// src/url.ts
var HOMEPAGE_LANGUAGE_OVERRIDE_PATH = "_HOMEPAGE_LANGUAGE_OVERRIDE_";
var isValidLanguageForSite = (site, language) => {
  const { languages: languages2 } = siteConfig[site];
  return languages2.indexOf(language) !== -1;
};
var assertValidLanguageForSite = (site, language, locale) => {
  if (!isValidLanguageForSite(site, language)) {
    const parsedValueMessage = language !== locale ? `, parsed from "${locale}"` : "";
    throw new Error(
      `Site "${site}" doesn't support language "${language}"${parsedValueMessage}`
    );
  }
};
var inferLanguageForSite = (site, currLanguage) => isValidLanguageForSite(site, currLanguage) ? currLanguage : siteConfig[site].languages[0];
var getLocalizedPath = ({ language, path, site }) => {
  if (path === HOMEPAGE_LANGUAGE_OVERRIDE_PATH) {
    if (isNonStandardHomepageLanguageSite(site)) {
      return language === defaultLanguage ? `/${defaultLanguage}` : "/";
    }
    path = "/";
  }
  if (language === defaultLanguage) {
    return path;
  }
  return joinPaths([language, path], {
    leading: true,
    trailing: path.length > 1 && path.endsWith("/")
  });
};
var getAbsoluteSiteUrl = ({
  site,
  path,
  staging,
  alternative
}) => {
  const targetHost = getHostName({ site, staging, alternative });
  return `https://${targetHost}${path}`;
};
var createUrlResolver = ({
  site,
  language: currentLanguage,
  staging = false,
  alternative
}) => {
  const currentClassification = siteConfig[site].classification;
  return ({
    product = currentClassification.product,
    language: requestedLanguage,
    path,
    absolute = false,
    ...rest
  }) => {
    const destinationCountry = (
      // Explicit undefined check rather than defaulting with a logical OR
      // as we want to use `rest.country` if it is explicitly set to null
      rest.country === void 0 ? currentClassification.country : rest.country
    );
    if (rest.country === null && !rest.brand) {
      throw new Error("You must provide a brand.");
    }
    const classificationInput = {
      product,
      country: destinationCountry,
      // @ts-expect-error Can't infer the type of `rest.brand`, but it doesn't matter as
      // getSiteNameFromClassification validates the input
      brand: rest.brand
    };
    const destinationSite = getSiteNameFromClassification(classificationInput);
    const language = requestedLanguage ? getLanguageFromLocale(requestedLanguage) : inferLanguageForSite(
      destinationSite,
      getLanguageFromLocale(currentLanguage)
    );
    assertValidLanguageForSite(
      destinationSite,
      language,
      requestedLanguage || currentLanguage
    );
    const localizedPath = getLocalizedPath({
      language,
      path,
      site: destinationSite
    });
    if (!absolute && destinationSite === site) {
      return localizedPath;
    }
    return getAbsoluteSiteUrl({
      site: destinationSite,
      path: localizedPath,
      staging,
      alternative
    });
  };
};
var getSiteNameFromClassification = ({
  product,
  ...rest
}) => {
  if (!rest.country && !rest.brand) {
    throw new Error(
      "You must provide a brand to get a root site (where country is `null`)"
    );
  }
  const site = rest.country ? findNonRootSite(product, rest.country) : findRootSite(product, rest.brand);
  if (!site) {
    const debugInfo = Object.entries({
      product,
      country: rest.country,
      brand: rest.country ? void 0 : rest.brand
    }).map(([key, value]) => `  - ${key}: ${JSON.stringify(value)}`).join("\n");
    throw new Error(`No matching site for:
${debugInfo}`);
  }
  return site;
};
var getHostName = ({
  site,
  staging,
  alternative
}) => {
  const { host, stagingHost } = siteConfig[site];
  const primaryHost = staging ? stagingHost : host;
  const alternativeHost = alternative ? getAlternativeHost(site, staging, alternative) : void 0;
  return alternativeHost ?? primaryHost;
};
var getAllHostNames = ({
  site,
  staging
}) => {
  const { host, stagingHost } = siteConfig[site];
  const primaryHost = staging ? stagingHost : host;
  const alternativeHosts = getAlternativeHosts(site, staging);
  return [primaryHost, ...alternativeHosts];
};
var getClassificationFromSiteName = (siteName) => siteConfig[siteName].classification;
var getSiteNameFromCountryAndProduct = ({
  country,
  product
}) => getSiteNameFromClassification({ country, product });
var createAbsoluteUrl = (props) => {
  const {
    product,
    country,
    language,
    path,
    staging = false,
    alternative
  } = props;
  const localized = "localized" in props ? props.localized : true;
  const site = getSiteNameFromCountryAndProduct({ product, country });
  let resolvedPath = path;
  if (localized) {
    if (!language) {
      throw new Error(
        `Missing language on localized route "${path}". Did you mean to set localized to false?`
      );
    }
    const normalizedLanguage = getLanguageFromLocale(language);
    assertValidLanguageForSite(site, normalizedLanguage, language);
    resolvedPath = getLocalizedPath({
      language: normalizedLanguage,
      path,
      site
    });
  }
  return getAbsoluteSiteUrl({
    site,
    path: resolvedPath,
    staging,
    alternative
  });
};
var hostnameToSiteName = Object.fromEntries(
  objectKeys(siteConfig).flatMap(
    (site) => [
      ...getAllHostNames({ site, staging: false }),
      ...getAllHostNames({ site, staging: true })
    ].map((hostname) => [hostname, site])
  )
);
var getSiteNameFromHostname = (hostname) => {
  if (!(hostname in hostnameToSiteName)) {
    throw new Error(`Unknown hostname: "${hostname}"`);
  }
  return hostnameToSiteName[hostname];
};

// src/zones.ts
var zoneToCountry = {
  "anz-1": "au",
  "anz-2": "nz",
  "asia-1": "hk",
  "asia-3": "th",
  "asia-4": "id",
  "asia-5": "my",
  "asia-6": "ph",
  "asia-7": "sg"
};
var isZone = (value) => value in zoneToCountry;
var getSiteFromZoneAndProduct = (zone, product) => {
  const country = zoneToCountry[zone];
  try {
    return getSiteNameFromCountryAndProduct({ country, product });
  } catch (cause) {
    throw new Error(`No site with zone "${zone}" and product "${product}"`, {
      cause
    });
  }
};
var getZoneFromSite = (site) => {
  const zones = objectKeys(zoneToCountry);
  const { classification } = siteConfig[site];
  const { country } = classification;
  const matchingZone = zones.find((zone) => zoneToCountry[zone] === country);
  if (!matchingZone) {
    throw new Error(`No zone matching site "${site}"`);
  }
  return matchingZone;
};

// src/get-localized-routes.ts
var getLocalizedRoutes = (baseRoutes) => (site) => baseRoutes.flatMap((routeData) => {
  const { languages: languages2 } = siteConfig[site];
  return languages2.map((language) => {
    const locale = getLocale(site, language);
    const route = language === defaultLanguage ? routeData.route : joinPaths([language, routeData.route], { leading: true });
    return {
      ...routeData,
      route,
      languages: [locale],
      language: locale
    };
  });
});
export {
  HOMEPAGE_LANGUAGE_OVERRIDE_PATH,
  appLanguages,
  createAbsoluteUrl,
  createUrlResolver,
  defaultLanguage,
  getAllHostNames,
  getClassificationFromSiteName,
  getHostName,
  getLanguageFromLocale,
  getLocale,
  getLocalizedRoutes,
  getSiteFromZoneAndProduct,
  getSiteNameFromClassification,
  getSiteNameFromCountryAndProduct,
  getSiteNameFromHostname,
  getZoneFromSite,
  isBrand as isMelwaysBrand,
  isCountry as isMelwaysCountry,
  isCountrySiteName as isMelwaysCountrySiteName,
  isLanguage as isMelwaysLanguage,
  isLocale as isMelwaysLocale,
  isProduct as isMelwaysProduct,
  isSiteName as isMelwaysSiteName,
  isZone as isMelwaysZone,
  languages,
  locales,
  siteConfig,
  siteNames
};
//# sourceMappingURL=index.js.map